import { render, staticRenderFns } from "./paywall-banner.vue?vue&type=template&id=5a72a8b2"
import script from "./paywall-banner.vue?vue&type=script&lang=js"
export * from "./paywall-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports